import CryptoJS from 'crypto-js';

export default (text, key, iv) => {
  const decrypt = CryptoJS.AES.decrypt(text, CryptoJS.enc.Hex.parse(key), {
    iv: CryptoJS.enc.Hex.parse(iv),
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  return decrypt.toString(CryptoJS.enc.Utf8);
};
